import { normalize } from 'normalizr';

import { notify } from 'utils/reduxUtils';

import { profitItemDefSchema } from './entities';

export const types = {
  CREATE_PROFIT_ITEM_ERROR: 'profitItems/listPage/CREATE_PROFIT_ITEM_ERROR',
  CREATE_PROFIT_ITEM_REQUEST: 'profitItems/listPage/CREATE_PROFIT_ITEM_REQUEST',
  CREATE_PROFIT_ITEM_SUCCESS: 'profitItems/listPage/CREATE_PROFIT_ITEM_SUCCESS',
  NEW_PROFIT_ITEM_MODAL_CLOSE:
    'profitItems/listPage/NEW_PROFIT_ITEM_MODAL_CLOSE',
  NEW_PROFIT_ITEM_MODAL_OPEN: 'profitItems/listPage/NEW_PROFIT_ITEM_MODAL_OPEN',
  RECEIVE_PROFIT_ITEM_DEFINITIONS:
    'profitItems/listPage/RECEIVE_PROFIT_ITEM_DEFINITIONS',
};

export const createProfitItem = {
  error: notify(
    (error) => ({
      type: types.CREATE_PROFIT_ITEM_ERROR,
      payload: error,
    }),
    'Failed to create Pricing Item',
  ),
  request: (payload) => ({
    type: types.CREATE_PROFIT_ITEM_REQUEST,
    payload,
  }),
  success: ({ profitItem }) => ({
    type: types.CREATE_PROFIT_ITEM_SUCCESS,
    payload: normalize(profitItem, profitItemDefSchema),
  }),
};

export const newProfitItemModal = {
  close: () => ({
    type: types.NEW_PROFIT_ITEM_MODAL_CLOSE,
  }),
  open: () => ({
    type: types.NEW_PROFIT_ITEM_MODAL_OPEN,
  }),
};

export const entities = {
  recieveProfitItemDefs: ({ profitItemDefs }) => ({
    type: types.RECEIVE_PROFIT_ITEM_DEFINITIONS,
    payload: normalize(profitItemDefs, [profitItemDefSchema]),
  }),
};
